import { useState } from "react";

// Components
import { SelectChangeEvent } from "@mui/material";

// Types
import { ChipEntity } from "types";
import { TElement } from "components/Autocomplete/AutocompleteField/hooks/useAutocompleteFunctionsLevels";
import { OptionsPillProps } from "components/FilterOptionsPill";

export type TBasicFunctionItem = {
    id: number;
    function: string;
    ids?: number[];
};

export const initFunction = {
    id: -1,
    function: "",
    ids: [],
} as TBasicFunctionItem;

const useSelectAndChips = ({
    type,
    items,
    setItems,
    list,
}: {
    type: OptionsPillProps["filterId"];
    items: ChipEntity[];
    setItems: React.Dispatch<React.SetStateAction<ChipEntity[]>>;
    list: TElement[];
}) => {
    const [showPlusIcon, setShowPlusIcon] = useState(true);

    const handleSelectChange = (ev: SelectChangeEvent) => {
        const value = ev.target.value;

        const itemToAdd = list.filter((element) => element.type === value)[0];
        const itemExists = items.some((item) => item.value === itemToAdd?.type);

        if (!itemExists) {
            setItems((items) => {
                return [
                    {
                        key: itemToAdd.id,
                        value: itemToAdd.type ?? "",
                        title: itemToAdd.name,
                        selected: true,
                    },
                    ...items,
                ];
            });
        } else {
            setItems(items.filter((item) => item.value !== value));
        }

        setShowPlusIcon(true);
    };

    const handleClickButtonPlus = (): void => {
        setShowPlusIcon(false);
    };

    const handleBlur = (): void => {
        setShowPlusIcon(true);
    };

    const handleRemoveItem = (item: ChipEntity) => {
        setItems(items.filter((i) => i.key !== item.key));
    };

    return {
        showPlusIcon,
        handleSelectChange,
        handleClickButtonPlus,
        handleBlur,
        handleRemoveItem,
    };
};

export default useSelectAndChips;
